import createIcon from './createIcon';

export default createIcon(require('./google.svg'));